import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8c7e40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "bottom" }

import 'normalize.css'
import HeaderView from '@/views/header/index.vue'
import BottomView from '@/views/bottom/index.vue'
import { ElConfigProvider } from 'element-plus'
// import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/theme-chalk/el-loading.css'
import 'element-plus/theme-chalk/index.css'
import '@/assets/css/index.css'
// import { ElLoading } from 'element-plus'
// import useMainStore from '@/stores/modules/main'
// import { storeToRefs } from 'pinia'
// import { watch } from 'vue'
// const mainStore = useMainStore()
// const { isLoading } = storeToRefs(mainStore)

// watch(
//   isLoading,
//   (value) => {
//     const loading = ElLoading.service({ fullscreen: true })
//     if (!value) {
//       loading.close()
//     }
//   },
//   {
//     immediate: true
//   }
// )

export default {
  __name: 'App',
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderView)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ElConfigProvider), null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx((props) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(props.Component)))
              ], 1024))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BottomView)
    ])
  ]))
}
}

}